import React from "react";
import { Icon } from "@iconify/react";

const BackHeader = ({ title, onBack }) => {
  return (
    <div className="back-header">
      <button
        className="back-header__btn"
        onClick={onBack}
        type="button"
        aria-label="Go back"
      >
        <Icon icon="weui:back-outlined" width="24" height="24" />
      </button>
      <h2 className="back-header__title">{title}</h2>
    </div>
  );
};

export default BackHeader;
